<template>
    <div>

        <template v-if="email">

               <div class="pa-4">



                <div class="text-center my-5 py-5">
                    Адрес электронной почты
                      <div class="d-flex justify-center">
                {{email}}
            </div>
                </div>

          

               </div>


            <sg-items-block>
                <v-list-item @click="editEmail">
                    
                    <v-list-item-icon>
                        <v-icon>mdi-pen</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content class="d-block">
                        <v-list-item-title>Изменить</v-list-item-title>
                        <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider style="margin-left: 56px;"/>

                <v-list-item @click="startDeleteEmail">
                    <v-list-item-icon>
                        <v-icon>mdi-delete</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content class="d-block">
                        <v-list-item-title>Удалить</v-list-item-title>
                        <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
  
            </sg-items-block>
        </template>

        <template v-else>


            <div class="pa-4">

                <div class="text-center my-4 py-4">
                    Адрес электронной почты не указан
                </div>

                <div class="text-body-2 grey--text">
<div>
Веденный электронный адрес позволяет использовать дополнительные сервисы:
</div>

<div class="pt-2">
Получение оповещений о необходимости внесения показаний счетчиков (оповещение будет доставлено за 1 день до окончания срока передачи показаний);
</div>

<div class="pt-2">
Получение квитанций на оплату жилищно-коммунальных услуг (в случае получения квитанций в электронном виде, печать квитанций в бумажном виде и их доставка в почтовые ящики производиться не будет).
</div>

<div class="pt-2">
Для получения электронного чека при оплате счетов и услуг
</div>
                </div>


          <!--       <div class="d-flex justify-center mt-5">
                    <v-btn @click="setEmail" color="primary" depressed>Указать</v-btn>
                </div> -->

            </div>

            <v-footer app>

                 <v-btn @click="setEmail" color="primary" block depressed>Указать</v-btn>
            </v-footer>


        </template>

    

        <sg-nav-back-btn class="mt-3"/>
    </div>
</template>

<script>


    export default {

        computed: {
            userInfo() {
                return this.$store.state.settings.userInfo
            },

            email() {
                return this.userInfo && this.userInfo.contacts.email
            }
        },
        methods: {
            setEmail() {
                this.$router.push({
                    name: 'wv-settings-email-edit'
                })
            },

            editEmail() {
                this.$router.push({
                    name: 'wv-settings-email-edit'
/*                     ,params: {
                        email: this.email
                    } */
                })
            },

            startDeleteEmail() {
                this.$eventBus.$emit('modal:dialog', {
                  
          /*                bottom: true, */
                    props: {
                        vertical: true,
                        message: "Отвязать адрес электронной почты от текущей карты?",
                        acceptText: 'Отмена',
                        rejectText: 'Принять'
                    },
                    dialogProps: {
                        noClickAnimation: true,
                        persistent: true
                    },
                    listeners: {
                        reject: () => {
                            this.deleteEmail()
                        }
                    }
                })
            },

            deleteEmail() {
                this.$eventBus.$emit('loader:show', {
                    overlay: true
                })
                this.$store.dispatch("settings/DELETE_EMAIL")
                .then( res => {
                    this.$eventBus.$emit('snackbar:open', {
                        message: "Адрес электронной почты отвязан"
                    })
                })
                .catch(error => {
                    this.$eventBus.$emit('error', error)
                })
                .finally(()=>{
                    this.$eventBus.$emit('loader:hide')
                })
            }
        }
    }
</script>

<style>

</style>